import { render, staticRenderFns } from "./AccreditationList.vue?vue&type=template&id=41584154&"
import script from "./AccreditationList.ts?vue&type=script&lang=ts&"
export * from "./AccreditationList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports